import { StatusBarStyle } from 'react-native'

import * as colors from 'styles/base/colors.css'

export const STATUS_BAR_STYLE: Record<'external'| 'internal' | 'shrunkSidebar', { backgroundColor: string, style: StatusBarStyle }> = {
  external: {
    backgroundColor: colors.headBgColorExternal,
    style: 'dark-content',
  },
  internal: {
    backgroundColor: colors.headBgColorInternal,
    style: 'light-content',
  },
  shrunkSidebar: {
    backgroundColor: colors.headBgColorShrunkSidebar,
    style: 'light-content',
  },
}
